import React, { useEffect, useState } from "react";
import Header from '../../Header/Header';
import SideBar from '../../SideBar/SideBar';
import Footer from '../../Footer/Footer';
import { Link } from 'react-router-dom';
import { getmasterDataEntity } from "../../HttpRequest/applyapplication";
import { useLocation } from 'react-router-dom';

const Adminuniversity = () => {

  const location = useLocation();
  const { state } = location;

  // const location = useLocation();
  // const { state } = location;


  // const [state, setState] = useState(location.state || {});
  const [universityDetails, setUniversityDetails] = useState();
  //const applicationId = universityDetails ? universityDetails.applicationId : null;

  useEffect(() => {
    console.log("data-->", state);
    const fetchData = async () => {
      try {
        const response = await getmasterDataEntity(state.id);
        console.log("response", response.data);
        setUniversityDetails(response.data)
      } catch (error) {
        console.error("Error fetching data:", error);
        // Handle the error, e.g., show a message to the user
      }
    };
    fetchData();
  }, []);


  return (
    <div className="main-wrapper">
      {/* Header */}
      <Header />

      {/* Sidebar */}
      <SideBar />

      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title"> University</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/admindashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Admin University</li>
                </ul>
              </div>
            </div>
          </div>
          {/* /Page Header */}

          {/* Display data from myObject */}
          <div className="carddesing m-1">
            {universityDetails ? (
              <div className="card singleuniversitygrid">

                {/* <div className="card-header">Featured</div>
              <div className="card-body">

              </div> */}


                <div className='universitycard-conatiner'>
                  <img src='https://upload.wikimedia.org/wikipedia/commons/c/cd/University-of-Alabama-EngineeringResearchCenter-01.jpg' alt='universit-image' className='university-image' />

                  <div className='textdes mt-2'>
                    <h6> <i class="fa-solid fa-building-columns me-1"></i>{universityDetails?.university}</h6>

                  </div>
                  <div className='textdes'>
                    <p><i class="fa-solid fa-location-dot"></i>  {universityDetails?.campus} </p>
                  </div>
                  <div className='textdes'>
                    <p><i class="fa-solid fa-globe"></i>  {universityDetails?.country} </p>
                  </div>
                  <div className='textdes'>
                    <p><i class="fa-solid fa-money-bills"></i>  Year tuition Fee : {universityDetails?.yearlyTuitionFees} </p>
                  </div>
                  <div className='textdes'>
                    <p><i class="fa-solid fa-comments-dollar"></i>  Application Fee : {universityDetails?.applicationFee} </p>
                  </div>
                  {/* <button className='btn btn-primary applystyle'>Apply Now</button> */}
                </div>
                <div className='university-space-container'></div>
                <div className='university-deatail-conatiner'>
                  <Link to="/adminstudentview">
                    <div className='circlebox'>
                      <div className='circlecontaner'>X</div>
                    </div>
                  </Link>
                  <div className='textdes mt-2'>
                    <h6 style={{ color: '#2C63E1', fontSize: '18px' }}> {universityDetails?.name}</h6>

                  </div>
                  <div className='textdes'>
                    <i class="fa-solid fa-graduation-cap"></i> <p > Study Level : {universityDetails?.studyLevel} </p>

                  </div>
                  <div className='textdes'>
                    <i class="fa-solid fa-graduation-cap"></i> <p > Duration : {universityDetails?.duration} </p>

                  </div>
                  <div className='textdes'>
                    <i class="fa-solid fa-graduation-cap"></i> <p > Application Time : <strong>{universityDetails?.applicationDeadline}</strong> </p>

                  </div>
                  <div className='mt-2'>
                    <h6 style={{ color: '#2C63E1' }}> Entry Requirements</h6>
                  </div>
                  <div className='mt-2'>
                    <div className='card cardbo'>
                      <div className='box'>
                        GRE
                        <p className='hrtag'></p>
                        {universityDetails?.grenoBandLessThan}
                        <p className='hrtag'></p>
                        {universityDetails?.greScore}
                      </div>
                      <div className='box'>
                        GPA
                        <p className='hrtag'></p>
                        {universityDetails?.gpanoBandLessThan}

                        <p className='hrtag'></p>
                        {universityDetails?.gpaScore}
                      </div>
                      <div className='box'>
                        IELTS
                        <p className='hrtag'></p>
                        {universityDetails?.ieltsnoBandLessThan}
                        <p className='hrtag'></p>
                        {universityDetails?.ieltsScore}
                      </div>
                      <div className='box'>
                        TOEFL
                        <p className='hrtag'></p>
                        {universityDetails?.tofelnoBandLessThan}
                        <p className='hrtag'></p>
                        {universityDetails?.tofelScore}
                      </div>

                      <div className='box'>
                        DET
                        <p className='hrtag'></p>
                        {universityDetails?.detnoBandLessThan}
                        <p className='hrtag'></p>
                        {universityDetails?.detScore}
                      </div>

                      <div className='box'>
                        PTE
                        <p className='hrtag'></p>
                        {universityDetails?.ptenoBandLessThan}
                        <p className='hrtag'></p>
                        {universityDetails?.pteScore}
                      </div>
                    </div>
                    <div className='textdes'>
                      <i class="fa-solid fa-graduation-cap"></i> <p > Intakes : <strong> {universityDetails?.intakes} </strong></p>

                    </div>
                    <p>ESL / ESP Details :  <a href={universityDetails?.eslelpDetail} target='_blank'>{universityDetails.masterDataEntity?.eslelpDetail}  </a></p>
                  </div>
                  <dv></dv>
                </div>
              </div>
            ) : (
              <p>No university details available.</p>
            )}
          </div>
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};


export default Adminuniversity;
